/** @format */

import * as Yup from "yup";
import parse from "date-fns/parse";

const objectIdRegex = /^[0-9a-fA-F]{24}$/; // Regex for MongoDB ObjectId validation

const signUpSchema = Yup.object().shape({
	firstName: Yup.string()
		.min(2, "First name too short")
		.max(50, "First name too long")
		.required("First name is required"),
	lastName: Yup.string()
		.min(2, "Last name too short")
		.max(50, "Last name too long")
		.required("Last name is required"),
	middleName: Yup.string()
		.min(2, "Middle name too short")
		.max(50, "Middle name too long")
		.optional()
		.nullable(),
	profileImage: Yup.string().optional().url("Invalid url").nullable(),
	email: Yup.string().email("Invalid email").required("Required"),
	hasAgreedToTerms: Yup.bool().required("Terms are required"),
	dateOfBirth: Yup.date()
		.transform(function (value, originalValue) {
			if (this.isType(value)) {
				return value;
			}
			const result = parse(originalValue, "dd.MM.yyyy", new Date());
			return result;
		})
		.typeError("please enter a valid date")
		.min(new Date("1969-11-13"), "Date is too early")
		.nullable()
		.notRequired(),
	password: Yup.string()
		.min(6, "Password too short")
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).*$/,
			"Password must have lowercase, uppercase characters, a number, and a special character",
		)
		.required("Password is required"),
	socialSecurityNumber: Yup.string().optional().nullable(),
	address: Yup.object({
		streetName: Yup.string().nullable(),
		zipCode: Yup.string().nullable(),
		city: Yup.string().nullable(),
		state: Yup.string().nullable(),
		county: Yup.string().nullable(),
		region: Yup.string().nullable(),
		country: Yup.string()
			.required("Country is required for verification")
			.min(2, "Please select a valid country"),
	})
		.nullable()
		.optional(),

	employer: Yup.object({
		employerName: Yup.string().nullable(),
		yearsWithEmployer: Yup.number().nullable(),
		income: Yup.number().nullable(),
		employerAddress: Yup.object({
			streetName: Yup.string().nullable(),
			zipCode: Yup.string().nullable(),
			city: Yup.string().nullable(),
			state: Yup.string().nullable(),
			county: Yup.string().nullable(),
			region: Yup.string().nullable(),
			country: Yup.string().nullable(),
		}),
	})
		.nullable()
		.optional(),

	phone: Yup.object({
		countryCode: Yup.string().nullable(),
		number: Yup.string().nullable(),
		e164: Yup.string().nullable(),
	})
		.nullable()
		.optional(),

	unions: Yup.array()
		.of(Yup.string().matches(objectIdRegex, "Invalid ID"))
		.nullable()
		.optional(),

	unionLeaderOf: Yup.array()
		.of(Yup.string().matches(objectIdRegex, "Invalid ID"))
		.nullable()
		.optional(),

	roles: Yup.array()
		.of(Yup.string().matches(objectIdRegex, "Invalid ID"))
		.nullable()
		.optional(),
});

export default signUpSchema;
